import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createSapStatus,
  getSapStatus,
  getSapStatusGenerateAll,
} from "./sapStatusAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchSapStatus = createAsyncThunk(
  "SapStatus/fetchSapStatus",
  async (payload) => {
    const response = await getSapStatus(payload);
    return response;
  }
);

export const fetchSapStatusGenerateAll = createAsyncThunk(
  "SapStatus/fetchSapStatusGenerateAll",
  async (payload) => {
    const response = await getSapStatusGenerateAll(payload);
    return response;
  }
);

export const addSapStatus = createAsyncThunk(
  "SapStatus/addSapStatus",
  async (payload) => {
    const response = await createSapStatus(payload);
    return response;
  }
);

export const sapStatusSlice = createSlice({
  name: "sapStatus",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSapStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSapStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })

      .addCase(fetchSapStatusGenerateAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSapStatusGenerateAll.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addSapStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(addSapStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = sapStatusSlice.actions;

export const selectSapStatus = (state) => state.sapStatus.data;
export const selectLoading = (state) => state.sapStatus.loading;
export const selectError = (state) => state.sapStatus.error;
export const selectPageNo = (state) => state.sapStatus.pageNo;
export const selectPageSize = (state) => state.sapStatus.pageSize;
export const selectTotalRecord = (state) => state.sapStatus.totalRecord;
export const selectSelected = (state) => state.sapStatus.selected;
export const selectResult = (state) => state.sapStatus.result;

export default sapStatusSlice.reducer;
